import { render, staticRenderFns } from "./EditEventForm.vue?vue&type=template&id=3397c47e&scoped=true&"
import script from "./EditEventForm.vue?vue&type=script&lang=js&"
export * from "./EditEventForm.vue?vue&type=script&lang=js&"
import style0 from "./EditEventForm.vue?vue&type=style&index=0&id=3397c47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3397c47e",
  null
  
)

export default component.exports